import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { PosEnumSelect } from 'src/core/POS/PosSelect';
import { ContentId } from 'src/utils/constants/contentId';
import { YES_NO_ENUM_FILTER_TO_CID } from 'src/utils/constants/contentIdMaps';
import { FromYesNoEnum, ToYesNoEnum } from 'src/utils/eventQueryUtils';

type IsConsignmentFilter = {
  isConsignment: boolean | null;
};

export const usePurchaseIsConsignmentFilters = <
  TFilter extends IsConsignmentFilter,
>({
  query,
  setQuery,
  enableEmptySelection,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
  enableEmptySelection?: boolean;
}): FilterToolbarItem => {
  return {
    filterId: 'isConsignment' as FilterToolbarItemId,
    labelContentId: ContentId.Consignment,
    filterQueryKeys: ['isConsignment'] as FilterToolbarItemId[],
    filterItem: (
      <PosEnumSelect
        style={{ width: '100%' }}
        value={ToYesNoEnum(query.isConsignment)}
        placeholderText={ContentId.All}
        enableEmptySelection={enableEmptySelection}
        onChange={(yesNoEnumValue) => {
          if (yesNoEnumValue !== ToYesNoEnum(query.isConsignment)) {
            setQuery({
              ...query,
              isConsignment: FromYesNoEnum(yesNoEnumValue),
            });
          }
        }}
        valueOptionsContent={YES_NO_ENUM_FILTER_TO_CID}
      />
    ),
  };
};
